import './App.css';
import Footer from '@/components/Footer';
import MusicTable from '@/components/MusicTable';
import ArtistPage from '@/pages/ArtistPage';
import ChristmasPage from '@/pages/ChristmasPage';
import ChronologyPage from '@/pages/ChronologyPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import RankingPage from '@/pages/RankingPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';
import { useEffect, useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate initial app loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent" />
          <span className="text-sm text-gray-300">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen font-poppins">
      <Router>
        <Routes>
          <Route path="/" element={<MusicTable />} />
          <Route path="/artist/:artistName" element={<ArtistPage />} />
          <Route path="/chronology" element={<ChronologyPage />} />
          <Route path="/chronology/christmas" element={<ChristmasPage />} />
          <Route path="/ranking" element={<RankingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" richColors closeButton expand={true} duration={3000} />
      </Router>
    </div>
  );
}

export default App;
